import { render, staticRenderFns } from "./nodatas.vue?vue&type=template&id=9902d91c&scoped=true"
import script from "./nodatas.vue?vue&type=script&lang=js"
export * from "./nodatas.vue?vue&type=script&lang=js"
import style0 from "./nodatas.vue?vue&type=style&index=0&id=9902d91c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9902d91c",
  null
  
)

export default component.exports